module.exports = __webpack_public_path__ + "img/lg_ring_y_l_0_1.ed277a10.png";